<template>
    <div class="login-container">
      <div class="glass-card">
        <h1 class="title">Forgot Password</h1>
        <p class="subtitle">Enter your email to receive a reset link</p>
  
        <div v-if="error" class="error-message">{{ error }}</div>
        <div v-if="message" class="success-message">{{ message }}</div>
  
        <form @submit.prevent="handleForgotPassword" v-if="!message">
          <div class="input-wrapper">
            <input type="email" placeholder="Your Email Address" class="input-field" v-model="email" required />
          </div>
  
          <button type="submit" class="login-btn" :disabled="loading">
            {{ loading ? 'Sending...' : 'Send Reset Link' }}
          </button>
        </form>
  
        <div class="links" style="justify-content: center; margin-top: 20px;">
           <router-link to="/login" class="sign-up">Back to Login</router-link>
         </div>
      </div>
    </div>
  </template>
  
  <script>
  // Option 1: If using Vuex (less common for forgot password)
  // import { mapActions } from 'vuex';
  
  // Option 2: If using an API service directly
  import authService from '@/services/authService'; // Adjust path as needed
  
  export default {
    name: 'ForgotPassword',
    data() {
      return {
        email: '',
        loading: false,
        error: null,
        message: null, // Used for success message
      };
    },
    methods: {
      // Option 1: If using Vuex
      // ...mapActions(['sendResetLink']), // Assuming you create this action
  
      async handleForgotPassword() {
        this.error = null;
        this.message = null;
        this.loading = true;
  
        // Basic email validation
        if (!/.+@.+\..+/.test(this.email)) {
             this.error = 'Please enter a valid email address.';
             this.loading = false;
             return;
        }
  
        try {
          // Option 1: Call Vuex action
          // const response = await this.sendResetLink({ email: this.email });
          // this.message = response?.data?.message || 'If an account exists for this email, a reset link has been sent.';
  
          // Option 2: Call API Service directly
          const response = await authService.forgotPassword({ email: this.email });
          this.message = response.data.message; // Display success message from backend
  
        } catch (err) {
          console.error("Forgot Password Error:", err);
          this.error = err?.response?.data?.message || err.message || 'An error occurred.';
          // Avoid revealing if the email exists or not on error for security
          // Consider setting a generic success message even on specific errors unless the backend handles it.
          // Example: If backend returns 404, you might still want to show the generic success message.
          // if (err.response?.status !== 404) { // Only show specific errors for non-404s maybe
               // this.error = ...
          // } else {
               // this.message = 'If an account exists...'; // Show generic success on 404
          // }
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Reuse styles from Register.vue or UserLogin.vue */
  .login-container { display: flex; justify-content: center; align-items: center; height: 100vh; background: linear-gradient(-45deg, #141e30, #243b55, #141e30); background-size: 400% 400%; animation: gradientAnimation 10s ease infinite; }
  .glass-card { background: rgba(255, 255, 255, 0.15); backdrop-filter: blur(12px); border-radius: 12px; padding: 40px; text-align: center; box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2); width: 350px; max-width: 100%; }
  .title { font-size: 24px; color: #fff; font-weight: bold; margin-bottom: 5px; }
  .subtitle { color: rgba(255, 255, 255, 0.8); font-size: 14px; margin-bottom: 20px; }
  .input-wrapper { width: 100%; position: relative; margin-bottom: 15px; }
  .input-field { width: 100%; max-width: 100%; box-sizing: border-box; padding: 12px; border: none; border-radius: 8px; font-size: 16px; background: rgba(255, 255, 255, 0.2); color: #fff; outline: none; }
  .input-field::placeholder { color: rgba(255, 255, 255, 0.7); }
  .login-btn { width: 100%; max-width: 100%; padding: 12px; font-size: 16px; font-weight: 500; border: none; border-radius: 8px; cursor: pointer; transition: transform 0.2s, box-shadow 0.2s; background: #4CAF50; color: white; }
  .login-btn:disabled { background: #aaa; cursor: not-allowed; }
  .login-btn:hover:enabled { transform: scale(1.05); box-shadow: 0 4px 10px rgba(255, 255, 255, 0.3); }
  .links { display: flex; justify-content: space-between; margin-top: 15px; font-size: 14px; }
  .sign-up { color: rgba(255, 255, 255, 0.8); text-decoration: none; transition: color 0.3s; }
  .sign-up:hover { color: #4CAF50; }
  .error-message { background-color: rgba(255, 0, 0, 0.2); color: #ffdddd; padding: 10px; border-radius: 5px; margin-bottom: 15px; border: 1px solid rgba(255, 0, 0, 0.3); font-size: 14px; }
  .success-message { background-color: rgba(0, 255, 0, 0.15); color: #ddffdd; padding: 10px; border-radius: 5px; margin-bottom: 15px; border: 1px solid rgba(0, 255, 0, 0.2); font-size: 14px; }
  @keyframes gradientAnimation { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
  </style>